var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Footer'),(_vm.isMagenta)?_c('tmo-digital-footer'):_c('tmo-digital-footer',{attrs:{"brand":"metro","client-id":"metro"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }